import { render } from "./LinkTask.vue?vue&type=template&id=49ceec41&scoped=true"
import script from "./LinkTask.vue?vue&type=script&lang=js"
export * from "./LinkTask.vue?vue&type=script&lang=js"

import "./LinkTask.vue?vue&type=style&index=0&id=49ceec41&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ceec41"]])

export default __exports__